import { render, staticRenderFns } from "./DetailProductHe.vue?vue&type=template&id=0d722cde&"
import script from "./DetailProductHe.vue?vue&type=script&lang=js&"
export * from "./DetailProductHe.vue?vue&type=script&lang=js&"
import style0 from "./DetailProductHe.vue?vue&type=style&index=0&id=0d722cde&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports